import React, { useContext, useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal'
import cl from './Add.module.css'
import Plus from "../../../../assets/Icon/Plus";
import { AppContext } from '../../../../providers/appProvider';
import { useTranslation } from 'react-i18next';

const AddRoleModal = ({ roleService, defaultRole }) => {
    const {t} = useTranslation();
    
    const roleResetData = {
        id: 0,
        name: "",
        description: "",
        permission_ids:[],
    }

    const [newRole, setNewRole] = useState(roleResetData)
    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [validates, setValidates] = useState({})
 
    const { appState, app } = useContext(AppContext);
    const permissions = appState.all_permissions;

    const validateRole = (role) => {
        const messages = {};

        if (role.name.length < 2) {
            messages.name = { message: 'მიუთითეთ სახელი', isValid: false };
        }

        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;
    };

    const reValidate = () => {
        const isValidate = validateRole(newRole)

    }

    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validateRole(newRole)
        }
    }, [newRole, isFirstValidated]);



    const [isModalOpen, setIsModalOpen] = useState(false);

    const saveHandle = () => {

        const isValidate = validateRole(newRole)
 
        if (isValidate === true) {
            roleService.add(newRole)
            setIsModalOpen(false)
        } else {
            setIsFirstValidated(true)
        }
 
    };

    const handleClientChange = async (event) => {
        let val = event.target.value;
        setNewRole(prevClient => ({
            ...prevClient,
            [event.target.name]: val
        }));
    };

    const openAdd = () => {
        setValidates({})
        setIsModalOpen(true)
        setIsFirstValidated(false)
        setNewRole(roleResetData)
    }

    const handleItemClick = (itemId) => {
        if (newRole.permission_ids.includes(itemId)) {
            setNewRole(prevClient => ({
                ...prevClient,
                permission_ids: newRole.permission_ids.filter(id => id !== itemId)
            }));  
        } else {
            setNewRole(prevClient => ({
                ...prevClient,
                permission_ids: [...newRole.permission_ids, itemId]
            })); 
        }
      };

    return (
        <div>

            <span onClick={() => openAdd()} className={cl.AddBtn}>
                <span className={cl.icon} ><Plus/></span> {t('Add')}
            </span>

            <Modal size="small" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>

                <div className={cl.modalHead} >
                    <h3>
                        <span className={cl.iconHead} > <Plus /></span> {t('Add')}
                    </h3>
                </div>
        

                <div className={ cl.groupInput }>
                        <input type="textS"
                        className={validates && validates.name ? cl.input + ' ' + cl.errorInput : cl.input}
                         name="name" id="name" value={newRole.name} onChange={handleClientChange} autoComplete="off" />
                        <label htmlFor="name">{t('Name')}</label>
                </div>

                <div className={ cl.groupInput }>
                    <input type="textS"
                    className={validates && validates.description ? cl.input + ' ' + cl.errorInput : cl.input}
                     name="description" id="description" value={newRole.description} onChange={handleClientChange} autoComplete="off" />
                    <label htmlFor="description">{t('Description')}</label>
                </div>
 
 
                <div className={ cl.rolesSelect }  >
                    <label>{t('Permissions')}</label>
                    <ul style={{ maxHeight: 'unset', overflowY: 'auto',   }}>
                        {permissions.map((item) => (
                            <li
                                key={item.id}
                                onClick={() => handleItemClick(item.id)}
                                className={newRole.permission_ids.includes(item.id) ? cl.selected : ' '}
                            >
                                {item.description}
                            </li>
                        ))}

                    </ul> 
                </div> 


                <span onClick={saveHandle} className={cl.btnPrimary}>{t('Add')}</span>
            </Modal>
        </div>
    );
};

export default AddRoleModal;